<template>
	<div>
		<div class="policy">
			<div class="main-title">
				关于印发《高新技术企业认定管理办法》的通知
			</div>
			<div class="flex flex-end clearfix">
				<el-button type="primary" @click="goback()">返回</el-button>
			</div>
			<div class="detail-content">
				<p>第一章 总 则</p>
				<p>
					第一条
					为扶持和鼓励高新技术企业的发展，根据《中华人民共和国企业所得税法》（以下称《企业所得税法》）、《中华人民共和国企业所得税法实施条例》（以下称《实施条例》）有关规定，特制定本办法。
				</p>
				<p>
					第二条
					本办法所称的高新技术企业是指：在《国家重点支持的高新技术领域》（见附件）内，持续进行研究开发与技术成果转化，形成企业核心自主知识产权，并以此为基础开展经营活动，在中国境内（不包括港、澳、台地区）注册一年以上的居民企业。
				</p>
				<p>
					第三条
					高新技术企业认定管理工作应遵循突出企业主体、鼓励技术创新、实施动态管理、坚持公平公正的原则。
				</p>
				<p>
					第四条
					依据本办法认定的高新技术企业，可依照《企业所得税法》及其《实施条例》、《中华人民共和国税收征收管理法》（以下称《税收征管法》）及《中华人民共和国税收征收管理法实施细则》（以下称《实施细则》）等有关规定，申请享受税收优惠政策。
				</p>
				<p>
					第五条
					科技部、财政部、税务总局负责指导、管理和监督全国高新技术企业认定工作。
				</p>
				<p>第二章 组织与实施</p>
				<p>
					第六条
					科技部、财政部、税务总局组成全国高新技术企业认定管理工作领导小组（以下称“领导小组”），其主要职责为：
				</p>
				<p>
					（一）确定全国高新技术企业认定管理工作方向，审议高新技术企业认定管理工作报告；
				</p>
				<p>（二）协调、解决认定及相关政策落实中的重大问题；</p>
				<p>
					（三）裁决高新技术企业认定事项中的重大争议，监督、检查各地区认定工作；
				</p>
				<p>（四）对高新技术企业认定工作出现重大问题的地区，提出整改意见。</p>
				<p>第七条 领导小组下设办公室。办公室设在科技部，其主要职责为：</p>
				<p>（一）提交高新技术企业认定管理工作报告；</p>
				<p>（二）组织实施对高新技术企业认定管理工作的检查；</p>
				<p>（三）负责高新技术企业认定工作的专家资格的备案管理；</p>
				<p>（四）建立并管理“高新技术企业认定管理工作网”；</p>
				<p>
					第八条
					各省、自治区、直辖市、计划单列市科技行政管理部门同本级财政、税务部门组成本地区高新技术企业认定管理机构（以下称“认定机构”），根据本办法开展下列工作：
				</p>
				<p>（一）负责本行政区域内的高新技术企业认定工作；</p>
				<p>（二）接受企业提出的高新技术企业资格复审；</p>
				<p>（三）负责对已认定企业进行监督检查，受理、核实并处理有关举报；</p>
				<p>（四）选择参与高新技术企业认定工作的专家并报领导小组办公室备案。</p>
				<p>
					第九条
					企业取得高新技术企业资格后，应依照本办法第四条的规定到主管税务机关办理减税、免税手续。
				</p>
				<p>
					享受减税、免税优惠的高新技术企业，减税、免税条件发生变化的，应当自发生变化之日起15日内向主管税务机关报告；不再符合减税、免税条件的，应当依法履行纳税义务；未依法纳税的，主管税务机关应当予以追缴。同时，主管税务机关在执行税收优惠政策过程中，发现企业不具备高新技术企业资格的，应提请认定机构复核。复核期间，可暂停企业享受减免税优惠。
				</p>
				<p>第三章 条件与程序</p>
				<p>第十条 高新技术企业认定须同时满足以下条件：</p>
				<p>
					（一）在中国境内（不含港、澳、台地区）注册的企业，近三年内通过自主研发、受让、受赠、并购等方式，或通过5年以上的独占许可方式，对其主要产品（服务）的核心技术拥有自主知识产权；
				</p>
				<p>（二）产品（服务）属于《国家重点支持的高新技术领域》规定的范围；</p>
				<p>
					（三）具有大学专科以上学历的科技人员占企业当年职工总数的30%以上，其中研发人员占企业当年职工总数的10%以上；
				</p>
				<p>
					（四）企业为获得科学技术（不包括人文、社会科学）新知识，创造性运用科学技术新知识，或实质性改进技术、产品（服务）而持续进行了研究开发活动，且近三个会计年度的研究开发费用总额占销售收入总额的比例符合如下要求：
				</p>
				<p>1. 最近一年销售收入小于5,000万元的企业，比例不低于6%；</p>
				<p>2. 最近一年销售收入在5,000万元至20,000万元的企业，比例不低于4%；</p>
				<p>3. 最近一年销售收入在20,000万元以上的企业，比例不低于3%。</p>
				<p>
					其中，企业在中国境内发生的研究开发费用总额占全部研究开发费用总额的比例不低于60%。企业注册成立时间不足三年的，按实际经营年限计算；
				</p>
				<p>（五）高新技术产品（服务）收入占企业当年总收入的60%以上；</p>
				<p>
					（六）企业研究开发组织管理水平、科技成果转化能力、自主知识产权数量、销售与总资产成长性等指标符合《高新技术企业认定管理工作指引》（另行制定）的要求。
				</p>
				<p>第十一条 高新技术企业认定的程序如下：</p>
				<p>（一）企业自我评价及申请</p>
				<p>
					企业登录“高新技术企业认定管理工作网”，对照本办法第十条规定条件，进行自我评价。认为符合认定条件的，企业可向认定机构提出认定申请。
				</p>
				<p>（二）提交下列申请材料</p>
				<p>1. 高新技术企业认定申请书；</p>
				<p>2. 企业营业执照副本、税务登记证（复印件）；</p>
				<p>
					3.
					知识产权证书（独占许可合同）、生产批文，新产品或新技术证明（查新）材料、产品质量检验报告、省级以上科技计划立项证明，以及其他相关证明材料；
				</p>
				<p>4. 企业职工人数、学历结构以及研发人员占企业职工的比例说明；</p>
				<p>
					5.
					经具有资质的中介机构鉴证的企业近三个会计年度研究开发费用情况表（实际年限不足三年的按实际经营年限），并附研究开发活动说明材料；
				</p>
				<p>
					6.
					经具有资质的中介机构鉴证的企业近三个会计年度的财务报表（含资产负债表、损益表、现金流量表，实际年限不足三年的按实际经营年限）以及技术性收入的情况表。
				</p>
				<p>（三）合规性审查</p>
				<p>
					认定机构应建立高新技术企业认定评审专家库；依据企业的申请材料，抽取专家库内专家对申报企业进行审查，提出认定意见。
				</p>
				<p>（四）认定、公示与备案</p>
				<p>
					认定机构对企业进行认定。经认定的高新技术企业在“高新技术企业认定管理工作网”上公示15个工作日，没有异议的，报送领导小组办公室备案，在“高新技术企业认定管理工作网”上公告认定结果，并向企业颁发统一印制的“高新技术企业证书”。
				</p>
				<p>
					第十二条
					高新技术企业资格自颁发证书之日起有效期为三年。企业应在期满前三个月内提出复审申请，不提出复审申请或复审不合格的，其高新技术企业资格到期自动失效。
				</p>
				<p>
					第十三条
					高新技术企业复审须提交近三年开展研究开发等技术创新活动的报告。
				</p>
				<p>
					复审时应重点审查第十条（四）款，对符合条件的，按照第十一条（四）款进行公示与备案。
				</p>
				<p>
					通过复审的高新技术企业资格有效期为三年。期满后，企业再次提出认定申请的，按本办法第十一条的规定办理。
				</p>
				<p>
					第十四条
					高新技术企业经营业务、生产技术活动等发生重大变化（如并购、重组、转业等）的，应在十五日内向认定管理机构报告；变化后不符合本办法规定条件的，应自当年起终止其高新技术企业资格；需要申请高新技术企业认定的，按本办法第十一条的规定办理。
				</p>
				<p>
					高新技术企业更名的，由认定机构确认并经公示、备案后重新核发认定证书，编号与有效期不变。
				</p>
				<p>第四章 罚 则</p>
				<p>第十五条 已认定的高新技术企业有下述情况之一的，应取消其资格：</p>
				<p>（一）在申请认定过程中提供虚假信息的；</p>
				<p>（二）有偷、骗税等行为的；</p>
				<p>（三）发生重大安全、质量事故的；</p>
				<p>（四）有环境等违法、违规行为，受到有关部门处罚的。</p>
				<p>
					被取消高新技术企业资格的企业，认定机构在5年内不再受理该企业的认定申请。
				</p>
				<p>
					第十六条
					参与高新技术企业认定工作的各类机构和人员对所承担认定工作负有诚信以及合规义务，并对申报认定企业的有关资料信息负有保密义务。违反高新技术企业认定工作相关要求和纪律的，给予相应处理。
				</p>
				<p>第五章 附 则</p>
				<p>
					第十七条
					原《国家高新技术产业开发区外高新技术企业认定条件和办法》（国科发火字[1996]018号）、原《国家高新技术产业开发区高新技术企业认定条件和办法》（国科发火字[2000]324号），自本办法实施之日起停止执行。
				</p>
				<p>第十八条 本办法由科技部、财政部、税务总局负责解释。</p>
				<p>
					第十九条
					科技部、财政部、税务总局另行制定《高新技术企业认定管理工作指引》。
				</p>
				<p>第二十条 本办法自2008年1月1日起实施。</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/form.scss";
</style>